import { useEffect } from "react";

// Keeps --app-h equal to the visible viewport so the on-screen keyboard never covers the input.
export default function useViewportHeight() {
  useEffect(() => {
    const vv = window.visualViewport;
    const set = () => {
      document.documentElement.style.setProperty("--app-h", `${vv ? vv.height : window.innerHeight}px`);
      window.scrollTo(0, 0);
    };
    set();
    vv?.addEventListener("resize", set);
    window.addEventListener("resize", set);
    return () => {
      vv?.removeEventListener("resize", set);
      window.removeEventListener("resize", set);
    };
  }, []);
}
